import React from 'react';
import { Button, ButtonProps } from '@mui/material';

export default function SecondaryButton(props: ButtonProps) {
  return (
    <Button
      color="buttonsTonalInverse"
      sx={{
        'borderColor': 'buttonsTonalInverse.main',
        '&:hover': {
          color: 'buttonsTonalInverse.light',
          borderColor: 'buttonsTonalInverse.light',
        },
      }}
      variant="outlined"
      {...props}
    ></Button>
  );
}
